import { render } from "./Main.vue?vue&type=template&id=58b2c9f9"
const script = {}
script.render = render

export default script